{
    "ReportlistMyreportlist": "Meine Berichtsliste",
    "ReportlistAddreport": "Bericht hinzufügen",
    "ReportlistDeletereport": "Bericht löschen",
    "ReportlistMoreoptions": "Mehr Optionen",
    "ReportlistModifyreport": "Bericht ändern",
    "ReportlistCopyreport": "Bericht kopieren",
    "ReportlistRenamefolder": "Ordner umbenennen",
    "ReportlistRenamereport": "Bericht umbenennen",
    "NoreportsconfiguredText": "Keine Berichte konfiguriert.",
    "ReportlistRecyclebin": "Papierkorb",
    "ReportlistEmptyrecyclebin": "Papierkorb leeren",
    "ReportlistRestoreallreports": "Alle Berichte wiederherstellen",
    "ReportlistRestorereport": "Bericht wiederherstellen",
    "ReportlistDeletereportsinfolder": "Ordnerinhalt löschen",
    "ReportlistRestorereportsinfolder": "Ordnerinhalt wiederherstellen",
    "ReportlistNotAllCompleted": "{} von {} ausgewählten Berichten wurden in den Papierkorb verschoben.",
    "ReportlistOutof": "aus",
    "ReportlistNoreportswererestored": "Es wurden keine Berichte wiederhergestellt.",
    "ReportlistReportwasrestored": "Bericht wurde wiederhergestellt.",
    "ReportlistReportswererestored": "{} Berichte wurden wiederhergestellt.",
    "ReportlistXoutofyselectedreportswererestored": "{} von {} ausgewählten Berichten wurden wiederhergestellt.",
    "ReportlistRestoregenericfailurereason": "Die fehlgeschlagenen Berichte wurden möglicherweise bereits wiederhergestellt oder dauerhaft gelöscht.",
    "ReportlistNoreportsweremovedtobin": "Es wurden keine Berichte in den Papierkorb verschoben.",
    "ReportlistReportwasmovedtobin": "Der Bericht wurde in den Papierkorb verschoben.",
    "ReportlistReportsweremovedtobin": "{} Berichte wurden in den Papierkorb verschoben.",
    "ReportlistXoutofyselectedreportsweremovedtobin": "{} von {} ausgewählten Berichten wurden in den Papierkorb verschoben.",
    "ReportlistMovetobingenericfailurereason": "Die fehlgeschlagenen Berichte wurden möglicherweise bereits in den Papierkorb verschoben.",
    "ReportlistThirtydaysremaining": "Dieser verbleibt 30 Tage oder bis zur Leerung in Ihrem Recyclingbehälter.",
    "ReportlistBeendeleted": "wurde gelöscht.",
    "ReportlistNoreportsweredeletedpermanently": "Es wurden keine Berichte endgültig gelöscht.",
    "ReportlistReportwasdeletedpermanently": "Der Bericht wurde endgültig gelöscht.",
    "ReportlistReportsweredeletedpermanently": "{} Berichte wurden dauerhaft gelöscht.",
    "ReportlistXoutofyselectedreportsweredeletedpermanently": "{} von {} ausgewählten Berichten wurden dauerhaft gelöscht.",
    "ReportlistDeletepermanentlygenericfailurereason": "Die fehlgeschlagenen Berichte wurden möglicherweise bereits endgültig gelöscht oder wiederhergestellt und befinden sich nicht mehr im Papierkorb.",
    "ReportlistMoveToBinCondition": "Dieses Dialogfeld in Zukunft nicht mehr anzeigen.",
    "ReportlistNoreportswerecopied": "Es wurden keine Berichte kopiert.",
    "ReportlistReportwascopied": "Bericht wurde kopiert.",
    "ReportlistReportswerecopied": "{} Berichte wurden kopiert.",
    "ReportlistXoutofyselectedreportswerecopied": "{} von {} ausgewählten Berichten wurden kopiert.",
    "ReportlistCopygenericfailurereason": "Die fehlgeschlagenen Berichte wurden möglicherweise bereits in den Papierkorb verschoben.",
    "NAME": "LanguageMyReportList",
    "ReportlistAdddefaultreport": "Standardbericht hinzufügen",
    "ReportListCopyReportsSuccessfulMessage": "Erfolgreich {} Bericht(e) kopiert",
    "ReportlistOverrideExistingReport": "Kreuzen Sie an, wenn Sie Ihre bestehenden Berichte überschreiben möchten.",
    "ReportlistReportsKeptForThirtyDays": "Überschriebene Berichte werden 30 Tage lang oder bis zum Leeren des Papierkorbs im Papierkorb aufbewahrt."
}